export default "__VITE_ASSET__BH0DOsGW__"